// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.check-multiple-tournament-list__list__title{
    padding: 12px 24px;
    border-bottom: 1px solid var(--new-gray-background-color);
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.check-multiple-tournament-list__list__title.baloa-table{
    color: var(--primary-very-dark-color);
}

.check-multiple-tournament-list__list__title .hubicon-clear_option {
    font-size: 14px;
    cursor: pointer;
}

.check-multiple-tournament-list__list-button.MuiButton-text{
    padding: 8px 12px;
    border: 1px solid var(--new-gray-color);
    border-radius: 5px;
    margin-right: 16px;
}

.check-multiple-tournament-list__list-button.filtered{
    display: flex;
    padding: 8px 12px;
    border-radius: 5px;
    margin-right: 16px;
    border: 1px solid var(--new-green-color);
    background: #E6F6EC;
}

.check-multiple-tournament-list__list-button .baloa-table{
    color: var(--black-color);
    display: flex;
    align-items: center;
    text-transform: none;
}

.check-multiple-tournament-list__list-button.filtered .baloa-table{
    color: var(--new-green-color);
}

.check-multiple-tournament-list__list-button.filtered .baloa-table .round-point{
    border-radius: 50%;
    background: var(--new-green-color);
    color: var(--white-color);
    font-size: 13px;
    width: 20px;
    height: 20px;
    line-height: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.check-multiple-tournament-list__list-button .hubicon-expand_more{
    font-size: 20px;
    margin-left: 16px;
}

.check-multiple-tournament-list__list-button .hubicon-clear_option{
    font-size: 20px;
    margin-left: 16px;
}

.check-multiple-tournament-list__buttons{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 12px 24px;
    border-top: 1px solid var(--new-gray-background-color);
    position: sticky;
    bottom: 0;
    background: var(--white-color);
}

.check-multiple-tournament-list__list .MuiList-padding{
    padding: 0;
    position: relative;
}

.check-multiple-tournament-list__list .MuiPaper-root{
    width: 500px;
    max-height: 600px;
}

.check-multiple-tournament-list__button-cancel{
    margin-right: 12px;
}

.check-multiple-tournament-list__list-item .baloa-normal-medium{
    color: var(--primary-dark-color);
}

.check-multiple-tournament-list__list-item .MuiListItemText-secondary .baloa-table-column{
    color: var(--primary-dark-color);
    padding: 3px 6px;
    border-radius: 25px;
    background-color: var(--new-grey-light-background-color);
    border: 1px solid var(--new-grey-border-color);
    margin-right: 4px;    
}

.check-multiple-tournament-list__list-item .MuiListItemText-secondary{
    margin-top: 4px;
}
.check-multiple-tournament-list__list-icon.MuiListItemIcon-root {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 4px;
}

.check-multiple-tournament-list__list-icon .icon-ball {
    color: var(--white-color);
    font-size: 35px;
    padding: 5px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.check-multiple-tournament-list__list-img{
    width: 44px;
    height: 44px;
    border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/check-multiple-tournament-list/CheckMultipleTournamentListComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,yDAAyD;IACzD,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,uCAAuC;IACvC,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,yBAAyB;IACzB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,sDAAsD;IACtD,gBAAgB;IAChB,SAAS;IACT,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,wDAAwD;IACxD,8CAA8C;IAC9C,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB","sourcesContent":[".check-multiple-tournament-list__list__title{\n    padding: 12px 24px;\n    border-bottom: 1px solid var(--new-gray-background-color);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.check-multiple-tournament-list__list__title.baloa-table{\n    color: var(--primary-very-dark-color);\n}\n\n.check-multiple-tournament-list__list__title .hubicon-clear_option {\n    font-size: 14px;\n    cursor: pointer;\n}\n\n.check-multiple-tournament-list__list-button.MuiButton-text{\n    padding: 8px 12px;\n    border: 1px solid var(--new-gray-color);\n    border-radius: 5px;\n    margin-right: 16px;\n}\n\n.check-multiple-tournament-list__list-button.filtered{\n    display: flex;\n    padding: 8px 12px;\n    border-radius: 5px;\n    margin-right: 16px;\n    border: 1px solid var(--new-green-color);\n    background: #E6F6EC;\n}\n\n.check-multiple-tournament-list__list-button .baloa-table{\n    color: var(--black-color);\n    display: flex;\n    align-items: center;\n    text-transform: none;\n}\n\n.check-multiple-tournament-list__list-button.filtered .baloa-table{\n    color: var(--new-green-color);\n}\n\n.check-multiple-tournament-list__list-button.filtered .baloa-table .round-point{\n    border-radius: 50%;\n    background: var(--new-green-color);\n    color: var(--white-color);\n    font-size: 13px;\n    width: 20px;\n    height: 20px;\n    line-height: 15px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.check-multiple-tournament-list__list-button .hubicon-expand_more{\n    font-size: 20px;\n    margin-left: 16px;\n}\n\n.check-multiple-tournament-list__list-button .hubicon-clear_option{\n    font-size: 20px;\n    margin-left: 16px;\n}\n\n.check-multiple-tournament-list__buttons{\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    padding: 12px 24px;\n    border-top: 1px solid var(--new-gray-background-color);\n    position: sticky;\n    bottom: 0;\n    background: var(--white-color);\n}\n\n.check-multiple-tournament-list__list .MuiList-padding{\n    padding: 0;\n    position: relative;\n}\n\n.check-multiple-tournament-list__list .MuiPaper-root{\n    width: 500px;\n    max-height: 600px;\n}\n\n.check-multiple-tournament-list__button-cancel{\n    margin-right: 12px;\n}\n\n.check-multiple-tournament-list__list-item .baloa-normal-medium{\n    color: var(--primary-dark-color);\n}\n\n.check-multiple-tournament-list__list-item .MuiListItemText-secondary .baloa-table-column{\n    color: var(--primary-dark-color);\n    padding: 3px 6px;\n    border-radius: 25px;\n    background-color: var(--new-grey-light-background-color);\n    border: 1px solid var(--new-grey-border-color);\n    margin-right: 4px;    \n}\n\n.check-multiple-tournament-list__list-item .MuiListItemText-secondary{\n    margin-top: 4px;\n}\n.check-multiple-tournament-list__list-icon.MuiListItemIcon-root {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 4px;\n}\n\n.check-multiple-tournament-list__list-icon .icon-ball {\n    color: var(--white-color);\n    font-size: 35px;\n    padding: 5px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.check-multiple-tournament-list__list-img{\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
